module.exports = __webpack_public_path__ + "img/equipPhoto1.dc56c56c.png";